import { render, staticRenderFns } from "./topMenu.vue?vue&type=template&id=5a6bbe98"
import script from "./topMenu.vue?vue&type=script&lang=js"
export * from "./topMenu.vue?vue&type=script&lang=js"
import style0 from "./topMenu.vue?vue&type=style&index=0&id=5a6bbe98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports